import { h, render, Component } from 'preact';
import { Wizard } from '../wizard'
import { PickDeviceType } from './pick-device-type';
import { PickDeviceOS } from './pick-device-os';
import { InfoAppInstall } from './info-app-install';
import { InfoAppActivate } from './info-app-activate';
import { InputPhoneNumber } from './input-phone-number';
import { InfoSmsActivate } from './info-sms-activate';
import { InfoVerifyLandline } from './info-verify-landline';
import { InfoVerifyMobile } from './info-verify-mobile';

export class DeviceEnrollmentWizard extends Component {

  constructor(props) {
    super(props);

    this.state = {
      deviceOS: '',
      deviceType: '',
      // errMsg: '',
      // errVisible: false,
      extension: '',
      // loading: false,
      phoneNumber: '',
      screen: 'explain'
    }

  }

  updateState = (stateObj) => {
    this.setState((prevState, props) => (stateObj));
  }

  componentDidUpdate() {
    // console.log(JSON.stringify(this.state));
  }

  formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return null
  }

  next = e => {
    var newState = {screen:'explain'};
    switch (this.state.screen) {
      case 'explain':
        newState.screen = 'pickDeviceType';
        break;
      case 'installApp':
        newState.screen = 'localActivate';
        if(this.state.deviceType == 'mobile')
          newState.screen = 'remoteActivate';
        break;
      case 'registerNumber':
        newState.phoneNumber = this.state.phoneNumber;

        if(this.state.deviceType == 'landline') {
          newState.extension = this.state.extension;
          newState.screen = 'verifyLandline';
        } else {
          newState.extension = '';
          newState.screen = 'verifyMobile';
        }
        break;
      case 'verifyMobile':
        newState.screen = 'installApp';
        break;
      case 'localActivate':
      case 'remoteActivate':
      case 'verifyLandline':
        this.props.updateAuthStage('awaitingSecondFactor');
        break;
    
      default:
        newState.screen = 'explain';
    }

    this.setState((prevState, props) => (newState));

  }

  prev = e => {
    var prevScreen = 'explain';
    switch (this.state.screen) {
      case 'pickDeviceType':
        prevScreen = 'explain';
        break;
      case 'pickDeviceOS':
      case 'registerNumber':
        prevScreen = 'pickDeviceType';
        break;
      case 'installApp':
        prevScreen = 'pickDeviceOS';
        break;
      case 'localActivate':
        prevScreen = 'installApp';
        break;
      case 'verifyLandline':
      case 'verifyMobile':
        prevScreen = 'registerNumber';
        break;
      default:
        prevScreen = 'explain';
    }

    this.setState((prevState, props) => ({
      screen: prevScreen
    }));

  }

  render(props, state) {
    switch (state.screen) {
      case 'pickDeviceType':
        return (
          <Wizard title="What kind of device would you like to use?" prev={{callback: this.prev}}>
            <PickDeviceType updateWizard={this.updateState}/>
          </Wizard>
        )

      case 'registerNumber':
        return <InputPhoneNumber updateWizard={this.updateState} deviceType={state.deviceType} deviceOS={state.deviceOS} phoneNumber={state.phoneNumber} extension={state.extension} prev={this.prev} next={this.next} />

      case 'verifyLandline':
        return <InfoVerifyLandline updateWizard={this.updateState} next={this.next} prev={this.prev} formattedPhoneNumber={this.formatPhoneNumber(state.phoneNumber)} phoneNumber={state.phoneNumber} extension={state.extension} />

      case 'verifyMobile':
        return <InfoVerifyMobile updateWizard={this.updateState} next={this.next} prev={this.prev} formattedPhoneNumber={this.formatPhoneNumber(state.phoneNumber)} phoneNumber={state.phoneNumber} deviceOS={state.deviceOS}/>

      case 'remoteActivate':
        return <InfoSmsActivate prev={this.prev} next={this.next} formattedPhoneNumber={this.formatPhoneNumber(state.phoneNumber)}/>

      case 'pickDeviceOS':
        return (
          <Wizard 
            title={"What type of "+(state.deviceType=='tablet'?'tablet':'phone')+" is it?"}
            prev={{callback: this.prev}}>
            <PickDeviceOS updateWizard={this.updateState} deviceType={state.deviceType}/>
          </Wizard>
        )

      case 'installApp':
        return <InfoAppInstall updateWizard={this.updateState} prev={this.prev} next={this.next} deviceOS={state.deviceOS} deviceType={state.deviceType} formattedPhoneNumber={this.formatPhoneNumber(state.phoneNumber)}/>

      case 'localActivate':
        return <InfoAppActivate prev={this.prev} next={this.next} deviceOS={state.deviceOS}/>

      default:
        return (
          <Wizard isPanel="true" 
            title="Stay secure by adding an extra layer of protection." 
            next={{callback: this.next, label: "Let's Get Started"}}>
            <p>
              Two-Factor authentication improves the security of your account by requiring a physical device to verify your identity. This prevents your account from being compromised in the event that an attacker has stolen your email and password. 
            </p>
          </Wizard>
        )
    }
    
  }
}
